import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import CategoryNav from './components/CategoryNav';
import TrendingVideos from './components/TrendingVideos';
import LatestContent from './components/LatestContent';
import CreatorHighlights from './components/CreatorHighlights';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <CategoryNav />
        <TrendingVideos />
        <LatestContent />
        <CreatorHighlights />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}